import { createSlice } from '@reduxjs/toolkit';

export const callqueueSlice = createSlice({
    name: 'callqueue',
    initialState: {
        addUser: [],
        userList: [],
    },
    reducers: {
        setAddCallQueueUser: (state, action) => {
            state.addUser = action.payload;
        },
        setCallQueueUserList: (state, action) => {
            state.userList = action.payload;
        }
    }
});

export const {
    setAddCallQueueUser,
    setCallQueueUserList
} = callqueueSlice.actions

export default callqueueSlice.reducer;